import * as React from 'react';
import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import { Link, useLocation } from 'react-router-dom';

import WorkspacesIcon from '@mui/icons-material/AppsRounded';
import LibraryIcon from '@mui/icons-material/CollectionsBookmarkRounded';
import ExploreIcon from '@mui/icons-material/TravelExploreRounded';
import ProjectsIcon from '@mui/icons-material/StyleRounded';
import TripIcon from '@mui/icons-material/MapRounded';
//import QuestIcon from "@mui/icons-material/FlagRounded";

const navItems = [
  { label: 'Workspaces', value: '/workspaces', icon: <WorkspacesIcon /> },
  { label: 'Projects', value: '/projects', icon: <ProjectsIcon /> },
  { label: 'Trips', value: '/trips', icon: <TripIcon /> },
  { label: 'Library', value: '/library', icon: <LibraryIcon /> },
  { label: 'Explore', value: '/explore', icon: <ExploreIcon /> }
  //{ label: "Quests", value: "/quests", icon: <QuestIcon /> },
];

export default function BottomTabBar() {
  const location = useLocation();
  const currentPath = navItems.find((item) => location.pathname.startsWith(item.value))?.value || '/';

  return (
    <Paper
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        display: { xs: 'block', sm: 'none' },
        zIndex: 999,
        height: '48px'
      }}
      elevation={3}
    >
      <BottomNavigation
        showLabels
        value={currentPath}
        sx={{
          height: '48px',
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            padding: '6px 8px'
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.7rem',
            '&.Mui-selected': {
              fontSize: '0.7rem'
            }
          }
        }}
      >
        {navItems.map((item) => (
          <BottomNavigationAction
            key={item.value}
            label={item.label}
            value={item.value}
            icon={item.icon}
            component={Link}
            to={item.value}
          />
        ))}
      </BottomNavigation>
    </Paper>
  );
}
